<template>
  <div class="container">
    <div class="cont">
      <div class="left">
        <div class="logo">
          <img src="../../../assets/images/LoginLogo.png" />
        </div>
      </div>
      <div class="right">
        <div class="Rcont">
          <div class="top">
            欢迎登录
            <p class="xian"><span></span></p>
          </div>
          <div class="bottom">
            <el-form ref="loginForm" :model="loginForm" :rules="loginRules">
              <div style="margin-bottom: 60px">
                <el-form-item prop="username">
                  <el-input
                    v-model="loginForm.username"
                    maxlength="20"
                    placeholder="请输入用户名"
                  ></el-input>
                  <i class="fa fa-user-o" aria-hidden="true"></i>
                </el-form-item>
                <el-form-item prop="password">
                  <el-input
                    v-model="loginForm.password"
                    maxlength="20"
                    show-password
                    placeholder="请输入密码"
                  ></el-input>
                  <i class="fa el-icon-lock"></i>
                </el-form-item>
                <el-form-item prop="validCode" class="codeItem">
                  <el-input
                    v-model="loginForm.validCode"
                    maxlength="5"
                    placeholder="请输入验证码"
                    style="width: 236px; margin-right: 10px"
                  ></el-input>
                  <i class="fa el-icon-set-up"></i>
                  <div class="coderight">
                    <img
                      :src="codeImg"
                      @click="getYzm()"
                      class="login-code-img"
                    />
                    <!-- <s-identify :identifyCode="identifyCode"></s-identify> -->
                  </div>
                </el-form-item>
              </div>
              <el-form-item>
                <el-button
                  type="primary"
                  @click="login()"
                  v-on:keyup.13.native="submit"
                  class="bigBtn"
                  style="width: 100%"
                  >登 录</el-button
                >
                <div class="card-foot">
                  <!-- <span @click="registerGo">注册</span> -->
                  <span @click="forgetPassword">忘记密码</span>
                </div>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
      <div class="footer">
        众顺达(安徽)数字科技有限公司
        <a
          target="_blank"
          href="https://beian.miit.gov.cn/#/Integrated/recordQuery"
          style="
            display: inline-block;
            text-decoration: none;
            height: 20px;
            line-height: 20px;
            color: #fff;
          "
          >京ICP备2022034202号</a
        >
        <a
          target="_blank"
          href="https://www.beian.gov.cn/portal/recordQuery?token=f4a9079d-5a5d-47a1-b5db-fb15bb3a617a"
          style="
            display: inline-block;
            text-decoration: none;
            height: 20px;
            line-height: 20px;
            color: #fff;
          "
        >
          <img src="../../../assets/images/gongwang.png" style="float: left" />
          京公网安备 11010502053555号
        </a>
      </div>
    </div>
    <!--是否发送短信弹框 -->
    <el-dialog
      :title="title"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :visible.sync="dialogVisible"
      :show-close="false"
      width="550px"
      center
    >
      <span>
        <el-form
          :model="isSendMessageFrom"
          ref="isSendMessageFrom"
          class="demo-form-inline"
          label-width="148px"
          size="mini"
        >
          <div class="addinpBox">
            <el-form-item label="验证码:" prop="name">
              <el-input
                placeholder="请输入验证码"
                maxlength="10"
                v-model.trim="isSendMessageFrom.name"
                style="width: 150px"
              ></el-input
              >&nbsp;&nbsp;&nbsp;
              <span
                v-if="isShowGetCode"
                class="identiCode"
                @click="getIdentifyCode"
                >获取验证码</span
              >
              <span v-else class="identiCode cancel-pointer"
                >{{ countdown }}s后可重试</span
              >
            </el-form-item>
          </div>
        </el-form>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          size="mini"
          @click="saveFn()"
          :loading="isSendMessageLoad"
          >提交短信验证码</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import {
  authOrg,
  checkOrg,
  externalAuth,
  loginUser,
  loginUserV2,
  setPropFlag
} from '@/api/common'
import store from '@/store'
import { encryption } from '@/utils/util'

export default {
  data () {
    return {
      // 是否发送短信
      title: '发送短信',
      dialogVisible: false,
      // isSendMessageFrom: {},
      isSendMessageLoad: false,
      countdown: 60,
      timer: '',
      isShowGetCode: true,
      // 表单数据对象
      loginForm: {
        grant_type: 'password',
        username: '',
        password: '',
        validCode: '',
        deviceId: ''
      },
      codeImg: '',
      // 校验规则对象
      loginRules: {
        // 定义字段对应的校验规则(多种)
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' }
        ],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
        validCode: [
          { required: true, message: '请输入验证码', trigger: 'blur' }
        ]
      },
      taken: '', // 获取token
      access_token: '', // 获取access_token
      menuDataList: [], // 用户菜单列表
      tel: '',
      smsCode: '', // 短信验证码
      isCutCrm3: null,
      baseUrl: null,
      // eslint-disable-next-line vue/no-dupe-keys
      // eslint-disable-next-line no-dupe-keys
      isSendMessageFrom: {
        name: ''
      }
    }
  },
  mounted () {
    document.title = '登录'
  },
  methods: {
    loginV2 () {
      this.$router.push({ path: '/NoLoginLoginV2' })
    },
    // 验证码
    getLoginCode () {
      let url = this.global.commonName + '/validata/code'
      let randomLenNum = this.randomLenNum(4, true)
      this.loginForm.deviceId = randomLenNum
      this.codeImg = url + '?deviceId=' + randomLenNum
    },
    getYzm () {
      this.getLoginCode()
    },

    // 随机数
    randomLenNum (len, date) {
      let random = ''
      random = Math.ceil(Math.random() * 100000000000000)
        .toString()
        .substr(0, len || 4)
      if (date) random = random + Date.now()
      return random
    },
    submit () {
      this.login()
    },
    // 点击登录
    login () {
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          store.delUser()
          localStorage.clear()
          sessionStorage.clear()
          let data = encryption({
            data: this.loginForm,
            key: this.global.key,
            param: ['password']
          })
          let Authorization1 = encryption({
            data: { Basic: this.global.headerBasic },
            type: 'Base64',
            param: ['Basic']
          })
          const loading = this.$loading({
            lock: true,
            text: '正在登录...'
          })
          this.$axios({
            headers: {
              Authorization: 'Basic ' + Authorization1.Basic
            },
            method: 'post',
            url: this.global.commonNameV2 + '/oauth/token',
            params: data
          })
            .then((res) => {
              loading.close()
              this.taken = res.data
              this.access_token = res.data.access_token
              this.isCutCrm3 = res.data.isCutCrm3
              localStorage.setItem('isCutCrm3', res.data.isCutCrm3)
              if (this.isCutCrm3 == 1) {
                // 0否，1是
                this.baseUrl = this.global.commonNameV2
              } else {
                this.baseUrl = this.global.commonName
              }
              this.$axios({
                headers: {
                  Authorization: 'Bearer ' + this.access_token
                },
                method: 'get',
                url: this.baseUrl + '/user/isCheckSMS'
                // params: data
              })
                .then((res) => {
                  let secondheckFlg = res.data.secondheckFlg
                  this.tel = res.data.mobile
                  if (secondheckFlg == '0') {
                    // 等于0不进行短信验证，直接登录
                    store.setUser(this.taken)
                    if (this.isCutCrm3 == 1) {
                      // 0否，1是
                      this.getLoginUserV2()
                    } else {
                      this.getLoginUser()
                    }
                    // let once = localStorage.getItem('once')
                    // console.log(once)
                    // if (once != '1') {

                    // }
                  } else {
                    // 验证短信
                    this.dialogVisible = true
                  }
                })
                .catch((error) => {
                  this.$message.error(error.message)
                })
            })
            .catch((error) => {
              loading.close()
              this.getYzm()
              this.$message.error(error.message)
            })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    // 获取用户信息
    getLoginUser () {
      loginUser().then((res) => {
        // 判断是否跳转认证信息页面
        // let menuList = res.menuList
        // let menuList = res.allowList[0].menuTree[0]
        this.$axios({
          headers: {
            Authorization: 'Bearer ' + this.access_token
          },
          method: 'post',
          url: this.global.crm + '/registerInfo/checkAndSkip',
          data: {}
        })
          .then((response) => {
            checkOrg().then((res1) => {
              if (response.data.flag == false) {
                // 等于false,需要认证
                this.$router.push({ path: '/common/authentication' })
                localStorage.setItem('businessFlg', response.data.type)
                localStorage.setItem('registerId', res.userId)
                // store.setUser(this.taken)
              } else {
                // this.$router.push({ path: menuList.menufuncIp })
                if (res.menuList != 0) {
                  localStorage.setItem('mobile', res.mobile)
                  localStorage.setItem('userCode', res.userCode)
                  localStorage.setItem('userName', res.userName)
                  localStorage.setItem('tenantName', res.tenantName)
                  localStorage.setItem('tenantCode', res.tenantCode)
                  localStorage.setItem('registerId', res.userId)
                  localStorage.setItem('businessFlg', res.businessFlg)
                  localStorage.setItem(
                    'tenantTaxpayerNumber',
                    res.tenantTaxpayerNumber
                  )
                  localStorage.setItem('isAdmin', res.isAdmin)
                  if (res.menuList[0].childMenu == 0) {
                    store.setIp(res.menuList[0].menufuncIp)
                    this.$router.push({ path: res.menuList[0].menufuncIp })
                  } else {
                    store.setIp(res.menuList[0].childMenu[0].menufuncIp)
                    this.$router.push({
                      path: res.menuList[0].childMenu[0].menufuncIp
                    })
                  }
                  this.menuDataList = res.menuList
                  this.menuDataList.forEach((item, index) => {
                    if (item.childMenu.length == 0) {
                      localStorage.setItem(
                        item.menufuncIp,
                        JSON.stringify(item.buttonList)
                      )
                    } else {
                      item.childMenu.forEach((item1, index) => {
                        localStorage.setItem(
                          item1.menufuncIp,
                          JSON.stringify(item1.buttonList)
                        )
                      })
                    }
                  })
                } else {
                  this.$message.error('该账号没有菜单权限！')
                  this.logout()
                }
              }
              // localStorage.setItem('once', '1')

              let rdata = res1
              if (rdata == '2') {
                this.$confirm(
                  '根据国家相关法律法规要求，需要进行实名认证。',
                  '提示',
                  {
                    confirmButtonText: '去认证',
                    cancelButtonText: '取消',
                    type: 'warning'
                  }
                )
                  .then(() => {
                    authOrg().then((res) => {
                      let url = res
                      if (url != '' && url != undefined) {
                        window.open(url)
                      }
                    })
                  })
                  .catch(() => {})
              }
              if (rdata == '3') {
                this.$confirm(
                  '企业已完成实名认证，但您不是企业印章管理员！',
                  '提示',
                  {
                    confirmButtonText: '申请授权',
                    cancelButtonText: '重新认证',
                    type: 'warning'
                  }
                )
                  .then(() => {
                    authOrg().then((res) => {
                      let url = res
                      if (url != '' && url != undefined) {
                        window.open(url)
                      }
                    })
                  })
                  .catch(() => {})
              }
              if (rdata == '4') {
                this.$confirm('您尚未进行电子签章授权！', '提示', {
                  confirmButtonText: '去授权',
                  cancelButtonText: '暂不授权',
                  type: 'warning'
                })
                  .then(() => {
                    externalAuth({ platform: 1 }).then((res) => {
                      let url = res
                      if (url != '' && url != undefined) {
                        window.open(url)
                      }
                    })
                  })
                  .catch(() => {
                    setPropFlag()
                  })
              }
            })
          })
          .catch((error) => {
            this.$message.error(error.message)
          })
      })
    },
    // 获取用户信息
    getLoginUserV2 () {
      loginUserV2().then((res) => {
        checkOrg().then((res1) => {
          // localStorage.setItem('once', '1')
          localStorage.setItem('registerId', res.userId)
          localStorage.setItem('mobile', res.mobile)
          localStorage.setItem('userCode', res.userCode)
          localStorage.setItem('userName', res.userName)
          localStorage.setItem('tenantName', res.tenantName)
          localStorage.setItem('tenantCode', res.tenantCode)
          localStorage.setItem('registerId', res.userId)
          localStorage.setItem('businessFlg', res.businessFlg)
          localStorage.setItem(
            'tenantTaxpayerNumber',
            res.tenantTaxpayerNumber
          )
          localStorage.setItem('userType', res.userType)
          localStorage.setItem('isAdmin', res.isAdmin)
          if (res.businessList) {
            res.businessList.forEach((item) => {
              res.tenantList.push({
                tenantCode: item.businessId,
                businessCode: item.businessCode,
                tenantName: item.businessName,
                flag: true
              })
            })
          }
          if (res.tenantList.length == 1) {
            localStorage.setItem(
              'isBusiness',
              res.businessList && res.businessList.length == 1 ? 1 : 2
            )
            localStorage.setItem(
              'createTenantCode',
              res.tenantList[0].tenantCode
            )
            localStorage.setItem(
              'createTenantName',
              res.tenantList[0].tenantName
            )
            this.$router.push({ path: '/' })
          } else if (res.tenantList.length > 1) {
            localStorage.setItem('tenantList', JSON.stringify(res.tenantList))
            this.$router.push({ path: '/selectOrg' })
          } else {
            this.$message.error('该账号无操作权限！')
            this.logout()
          }
          let rdata = res1
          if (rdata == '2') {
            this.$confirm(
              '根据国家相关法律法规要求，需要进行实名认证。',
              '提示',
              {
                confirmButtonText: '去认证',
                cancelButtonText: '取消',
                type: 'warning'
              }
            )
              .then(() => {
                authOrg().then((res) => {
                  let url = res
                  if (url != '' && url != undefined) {
                    window.open(url)
                  }
                })
              })
              .catch(() => {})
          }
          if (rdata == '3') {
            this.$confirm(
              '企业已完成实名认证，但您不是企业印章管理员！',
              '提示',
              {
                confirmButtonText: '申请授权',
                cancelButtonText: '重新认证',
                type: 'warning'
              }
            )
              .then(() => {
                authOrg().then((res) => {
                  let url = res
                  if (url != '' && url != undefined) {
                    window.open(url)
                  }
                })
              })
              .catch(() => {})
          }
          if (rdata == '4') {
            this.$confirm('您尚未进行电子签章授权！', '提示', {
              confirmButtonText: '去授权',
              cancelButtonText: '暂不授权',
              type: 'warning'
            })
              .then(() => {
                externalAuth({ platform: 1 }).then((res) => {
                  let url = res
                  if (url != '' && url != undefined) {
                    window.open(url)
                  }
                })
              })
              .catch(() => {
                setPropFlag()
              })
          }
        })
        // 判断是否跳转认证信息页面
        // let menuList = res.menuList
        // let menuList = res.allowList[0].menuTree[0]

        // this.$axios({
        //   headers: {
        //     Authorization: 'Bearer ' + this.access_token

        //   },
        //   method: 'post',
        //   url: this.global.crm + '/registerInfo/checkAndSkip',
        //   data: {}
        // })
        //   .then(response => {
        //     if (response.data.flag == false) {
        //       // 等于false,需要认证
        //       this.$router.push({ path: '/common/authentication' })
        //       localStorage.setItem('businessFlg', response.data.type)

        //       // store.setUser(this.taken)
        //     } else {
        //       // this.$router.push({ path: menuList.menufuncIp })
        //       if (res.menuList != 0) {

        //         // if (res.menuList[0].childMenu == 0) {
        //         //   store.setIp(res.menuList[0].menufuncIp)
        //         //   this.$router.push({ path: res.menuList[0].menufuncIp })
        //         // } else {
        //         //   if (res.menuList[0].childMenu.childMenu == 0) {
        //         //     store.setIp(res.menuList[0].childMenu.menufuncIp)
        //         //     this.$router.push({ path: res.menuList[0].childMenu.menufuncIp })
        //         //   } else {
        //         //     store.setIp(res.menuList[0].childMenu[0].childMenu[0].menufuncIp)
        //         //     this.$router.push({
        //         //       path: res.menuList[0].childMenu[0].childMenu[0].menufuncIp
        //         //     })
        //         //   }
        //         //   store.setIp(res.menuList[0].childMenu[0].childMenu[0].menufuncIp)
        //         //   this.$router.push({
        //         //     path: res.menuList[0].childMenu[0].childMenu[0].menufuncIp
        //         //   })
        //         // }
        //         // this.menuDataList = res.menuList
        //         // this.menuDataList.forEach((item, index) => {
        //         //   if (item.childMenu.length == 0) {
        //         //     localStorage.setItem(item.menufuncIp, JSON.stringify(item.buttonList))
        //         //   } else {
        //         //     item.childMenu.forEach((item1, index) => {
        //         //       localStorage.setItem(item1.menufuncIp, JSON.stringify(item1.buttonList))
        //         //     })
        //         //   }
        //         // })
        //       } else {
        //         this.$message.error('该账号没有菜单权限！')
        //       }
        //     }
        //   })
        //   .catch(error => {
        //     this.$message.error(error.message)
        //   })
      })
    },

    // 退出登录
    logout () {
      this.$axios
        .get(this.global.commonName + '/oauth/remove/token')
        .then((res) => {
          store.delUser()
          localStorage.clear()
          sessionStorage.clear()
          this.$router.push('/login')
        })
        .catch((error) => {
          this.$message.error(error.msg)
        })
    },
    // 点击是否发送短信确定按钮
    saveFn () {
      this.$axios({
        headers: {
          Authorization: 'Bearer ' + this.access_token
        },
        method: 'get',
        url: this.baseUrl + '/user/checkSMS',
        params: {
          mobile: this.tel,
          smsCode: this.isSendMessageFrom.name
        }
      })
        .then((res) => {
          store.setUser(this.taken)
          this.$message.success('短信验证成功！')
          if (this.isCutCrm3 == 1) {
            // 0否，1是
            this.getLoginUserV2()
          } else {
            this.getLoginUser()
          }
        })
        .catch((error) => {
          console.log(error)
          this.$message.error(error.message)
        })
    },
    // 点击获取验证码
    getIdentifyCode () {
      this.countDown()
      this.isShowGetCode = false
      this.$axios({
        headers: {
          Authorization: 'Bearer ' + this.access_token
        },
        method: 'get',
        url: this.global.commonName + '/user/sendSMS',
        params: {
          mobile: this.tel
        }
      })
        .then((res) => {
          // this.smsCode = res.data.smsCode
        })
        .catch((error) => {
          this.$message.error(error.message)
        })
    },
    countDown () {
      const self = this
      this.timer = setInterval(() => {
        self.countdown--
        if (self.countdown === 0) {
          clearInterval(self.timer)
          self.countdown = 60
          self.isShowGetCode = true
        }
      }, 1000)
    },
    // 注册
    registerGo () {
      this.$router.push('/common/register')
    },
    // 忘记密码
    forgetPassword () {
      this.$router.push('/common/forgetPass')
    }
  },
  created () {
    // 点击空格-登录
    var _this = this
    document.onkeydown = function (e) {
      let key = window.event.keyCode
      if (key == 13) {
        _this.submit()
      }
    }
    this.getLoginCode()
  }
}
</script>

<style scoped lang="less">
.container,
.cont {
  width: 100%;
  height: 100vh;
  min-width: 990px;
  min-height: 500px;
  background: #fff;
  display: flex;
  .left {
    width: 75%;
    background: url("../../../assets/images/loginBJ.jpg") no-repeat 50% / cover;
    .logo {
      width: 100%;
      padding: 30px;
      box-sizing: border-box;
      padding-left: 5%;
      background: linear-gradient(
        to right,
        rgba(255, 255, 255, 0.5),
        rgba(255, 255, 255, 0)
      );
      margin-top: 12%;
      img {
        width: 65%;
      }
    }
  }
  .right {
    width: 25%;
  }
}
.footer {
  position: fixed;
  bottom: 18px;
  width: 100%;
  font-size: 12px;
  color: #fff;
  text-align: center;
}
.Rcont {
  width: 80%;
  margin: 0 auto;
  margin-top: 36%;
  .top {
    text-align: center;
    color: #333333;
    font-size: 22px;
    border-bottom: 1px solid #ddd;
    padding-bottom: 10px;
    position: relative;
    margin-bottom: 50px;
    .xian {
      position: absolute;
      bottom: -4px;
      text-align: center;
      width: 100%;
      height: 3px;
      span {
        display: inline-block;
        width: 60px;
        height: 3px;
        background-color: #0e6eec;
      }
    }
  }
}
/deep/.el-input__inner {
  box-shadow: inset 0 0 0 1000px #ffffff !important;
  border: none;
  border-bottom: 1px solid #cccccc;
  padding-left: 28px;
}
/deep/ .el-form-item__content {
  position: relative;
  .fa {
    position: absolute;
    left: 6px;
    bottom: 8px;
    font-size: 18px;
    color: #0e6eec;
  }
}
.card-foot {
  display: flex;
  justify-content: space-between;
  color: #0e6eec;
  cursor: pointer;
}
.codeItem {
  position: relative;
  height: 40px;
  .codeInput {
    position: absolute;
    top: 0;
    left: 0;
    width: 62%;
    background-color: #fff;
    border: 1px solid #ccc;
    border-radius: 4px;
    font-size: 16px;
    padding: 0;
  }
  .coderight {
    position: absolute;
    top: 0;
    right: 0px;
    cursor: pointer;
    img {
      width: 120px;
      height: 40px;
    }
  }
}
/deep/.el-button--primary {
  background-color: #0e6eec;
  border-color: #0e6eec;
}
</style>
